// Stable React key for a media item. Falls back to the index for placeholders, which have no src.
export const getMediaItemKey = (item, index) => `${item.type}-${item.src ?? index}`
